import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppFoodTrackingInfoPopupPage } from './app-food-tracking-info-popup';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppFoodTrackingInfoPopupPage,
  ],
  imports: [
    IonicPageModule.forChild(AppFoodTrackingInfoPopupPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppFoodTrackingInfoPopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-food-tracking-info-popup/app-food-tracking-info-popup.module.ts